import React from 'react'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer';
import Menu from '../components/Menu';

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
  }

  render() {
    const { location, history, children } = this.props
    return (
      <div>
        <Helmet
          title="Patrícia Marques – Makeup Artist"
          meta={[
            { name: 'description', content: 'Makeup Artist sharing her work and emotions through different Makeup styles and techniques: TV&Cinema, Fashion, Brides, Events, Airbrush&Body Painting.' },
            { name: 'keywords', content: 'makeup, artist, tv, cinema, theater, advertising, brides, events' },
          ]}
        />
        <Header
          isHomepage={location.pathname === '/'}
          workSingle={location.pathname.match(/^\/work\//) !== null}
          isOpen={this.state.isOpen}
          menuToggle={this.toggle}
          goBack={history.goBack}
        />
        <Menu
          pathname={location.pathname}
          isOpen={this.state.isOpen}
          menuToggle={this.toggle}
        />
        <main css={{ maxWidth: 600, margin: '70px auto 0' }}>
          {children()}
        </main>
        <Footer instagram={this.props.data.instagram} />
      </div>
    )
  }
}

export default TemplateWrapper

export const workQuery = graphql`
  query InstagramImgs {
    instagram: allFile(filter: {relativePath: { regex: "/instagram-.+jpg/" } }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 300, maxHeight: 300, traceSVG: { color: "#021212" }) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js